
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, itemsModule, filterModule, itemTypesModule } from '@/store/modules/store-accessor'
import { isDecimalNumber, warrantyOptionUnit, warrantyUnitOptions, warrantyValueFromMonths } from '@/helpers/data';
import { greekSearchFilter } from "@/helpers/data";

@Component
export default class EditInventoryItemModal extends Vue {
  @Prop()
  payload!: any;
  modelSearch = '';
  makeSearch = '';
  isEditingItem = false;

  greekSearchFilter = greekSearchFilter;

    updItemModel = {
        make: this.payload.editItem.make,
        model: this.payload.editItem.model,
        model_year: this.payload.editItem.model_year,
        notes: this.payload.editItem.notes || '',
        warranty: warrantyValueFromMonths(this.payload.editItem.warranty, this.payload.editItem.warranty_option),
        warranty_option: warrantyOptionUnit(this.payload.editItem.warranty_option),
        item_type_id: {text: this.payload.editItem.type_name, id: this.payload.editItem.item_type_id},
        id: this.payload.editItem.id,
        cost: this.payload.editItem.cost || 0,
        unit: this.payload.editItem.unit ? this.findItemUnit(this.payload.editItem.unit) : this.defaultUnitType,
        is_unit_based: this.payload.editItem.is_unit_based || false
    }

  async hideModal () {
    commonModule.hideModal();
  }

  get itemFilters() {
    return filterModule.itemFilters;
  }

  get warrantyUnitOptions() {
    return warrantyUnitOptions(this.updItemModel.warranty);
  }

  async mounted() {
    commonModule.initSnackbar({});
    await commonModule.getPersonnelCombo();
    await commonModule.getActionCombo();
    await itemTypesModule.getItemTypesCombo();
    await commonModule.getFuelTypeCombo();
    await commonModule.getPlacementTypeCombo();
    await itemsModule.getItemsUnitsCombo();
  }

  itemTypeRule= [
    (val: any) => this.typeFound(val) || this.$i18n.t("item_type_required"),
  ]
  makeRule= [
    (val: any) => !!val || this.$i18n.t("make_required"),
  ]
  notesRule= [
    (val: any) => {
      if(val != null) return val.length <= 1000 || this.$i18n.t("notesLengthRule");
      else return true;
    },
  ]
  costRule = [ (val: any) => val !== '' && val >= 0 || this.$i18n.t("cost_required")];

  itemUnitRule = [
    (val: any) => ((!!val || val == '') && val.text.length > 0) || this.$i18n.t("itemUnitRequired"),
  ]

  get inventoryItemsCombo() {
      return itemTypesModule.itemTypesCombo;
  }

  doUpdate() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.isEditingItem = true;
      if(this.modelSearch && this.modelSearch.length > 0) {
        this.updItemModel.model = this.modelSearch;
      }
      if(this.makeSearch && this.makeSearch.length > 0) {
        this.updItemModel.make = this.makeSearch;
      }
      itemsModule.editItem(this.updItemModel);
      this.hideModal()
    }
  }

  typeFound(type: any) {
    if (type) {
      const found = this.inventoryItemsCombo?.find(item => {
        return item['text'] === type.text;
      });
      return found == undefined ? false : true;
    }
    return false;
  };

  isNumber(evt: any) {
      evt = evt || window.event;
      let charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
  }

  get itemsUnitsTypes() {
    return itemsModule.itemsUnitsCombo;
  }

  get defaultUnitType() {
    if(itemsModule.itemsUnitsCombo) {
      return itemsModule.itemsUnitsCombo.find((type: Record<string, any>) => type.enum_text === 'PIECES');
    }
    return '';
  }

  onlyDecimalNumbers(evt: any) {
    isDecimalNumber(evt);
  }

  findItemUnit(unitType: string) {
    let combo: any = itemsModule.itemsUnitsCombo;
    const foundType = combo.find((item: any) => item.enum_text == unitType);
    if(foundType) {
      return { text: this.$i18n.t(foundType.text), enum_text: unitType } as any;
    } else {
      return [] as any;
    }
  }

};
